import setReduxAction from '../set'

export default function updateStateReduxAction ({ actionType, state }) {
  return (dispatch) => {
    dispatch(setReduxAction({
      type: actionType,
      payload: {
        path: '',
        value: state
      }
    }))
  }
}
